/* VUEX State management and ajax store
 *
 */

module.exports = ( Vue, Vuex ) => { 
    Vue.use( Vuex );

    return new Vuex.Store({
        
        state: {
            bcLinks : [],
            
            user    : false, //Logged in user
        },

        mutations: {

            showLoader( state ) {
                state.isLoading = true;
            },

            hideLoader( state ) {
                state.isLoading = false;
            }

        }
    })

}